import { Component, OnInit } from '@angular/core';
import { UiService } from '../../services/ui/ui.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserManagerService } from 'src/app/services/user-manager/user-manager.service';
import {TreeNode} from 'primeng/api';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent implements OnInit {
  // files: TreeNode[];
  sidenavs = [
    {
      header: 'overview',
      previllege: this.userService.hasMenu('SPORTS_P_M_OVERVIEW'),
      others: [
        {
          name: 'dashboard',
          icon: 'dashboard',
          code: 'SPORTS_P_SM_DASHBOARD',
          url: 'dashboard'
        }
      ]
    },
    {
      header: 'sport_management',
      previllege: this.userService.hasMenu('SPORTS_P_M_SPORT_MANAGEMENT'),
      others: [
        {
          name: 'sport',
          icon: 'sport',
          code: 'SPORTS_P_SM_SPORT',
          url: 'sport'
        },
        {
          name: 'category',
          icon: 'category',
          code: 'SPORTS_P_SM_CATEGORIES',
          url: 'categories'
        },
        {
          name: 'tournament',
          icon: 'tournament',
          code: 'SPORTS_P_SM_TOURNAMENTS',
          url: 'tournament'
        },
        {
          name: 'event',
          icon: 'event',
          code: 'SPORTS_P_SM_EVENTS',
          url: 'event'
        },
        {
          name: 'game_list',
          icon: 'games',
          code: 'SPORTS_P_SM_GAMELISTS',
          url: 'games'
        },
      ]
    },
    {
      header: 'market_management',
      previllege: this.userService.hasMenu('SPORTS_P_M_MARKET_MANAGENT'),
      others: [
        {
          name: 'market',
          icon: 'market',
          code: 'SPORTS_P_SM_MARKET',
          url: 'market'
        },
        {
          name: 'group',
          icon: 'group',
          code: 'SPORTS_P_SM_GROUP',
          url: 'group'
        },
        {
            name: 'manual_odds',
            icon: 'group',
            code: 'SPORTS_P_SM_MANUAL_ODDS',
            url: 'manual-odds'
        }
      ]
    },
    {
      header: 'manage_clients',
      previllege: this.userService.hasMenu('SPORTS_P_M_CLIENT_MANAGEMENT'),
      others: [
        {
          name: 'clients',
          icon: 'client',
          code: 'SPORTS_P_SM_CLIENTS',
          url: 'clients'
        },
        { name: 'demo_accounts',
          icon: 'approval',
          code: 'P_SM_DEMO_CLIENT_ACCOUNT_MANAGEMENT',
          url: 'demo-accounts'
        },
        {
          name: 'self_exclusions',
          icon: 'block_visitor',
          code: 'SPORTS_P_SM_CLIENT_SELF_EXCLUSIONS',
          url: 'exclusions'
        },
        {
          name: 'self_limits',
          icon: 'locker_service_console',
          code: 'SPORTS_P_SM_CLIENT_SELF_LIMITS',
          url: 'limits'
        },
        {
          name: 'freebet_assignment',
          icon: 'client',
          code: 'SPORTS_P_SM_FREEBET_ASSIGNMENT',
          url: 'freebet-assignment'
        }
      ]
    },
    {
      header: 'channel_management',
      previllege: this.userService.hasMenu('SPORTS_P_M_CHANEL_MANAGEMENT'),
      others: [
        {
          name: 'channel',
          /* icon: 'fas fa-dot-circle', */
          icon: 'channel',
          code: 'SPORTS_P_SM_CHANNEL',
          url: 'channel'
        }
      ]
    },
    {
      header: 'publicity',
      previllege: this.userService.hasMenu('SPORTS_P_M_PUBLICITY'),
      others: [
        {
          name: 'sliders',
          icon: 'publicity',
          code: 'SPORTS_P_SM_SLIDDERS',
          url: 'publicity'
        },
        {
          name: 'text_slides',
          icon: 'text-slides',
          code: 'SPORTS_P_SM_TEXTSLIDES',
          url: 'text-slidders'
        }
      ]
    },
    {
      header: 'sport_promo_mgt',
      previllege: this.userService.hasMenu('SPORTS_P_M_PROMOTIONS'),
      others: [
        {
          name: 'sport_promotions',
          icon: 'publicity',
          code: 'SPORTS_P_SM_SPORT_PROMOTION',
          url: 'sport-promotions'
        },
        {
          name: 'text_slides',
          icon: 'text-slides',
          code: 'SPORTS_P_SM_TEXTSLIDES',
          url: 'text-slidders'
        }
      ]
    },
    {
      header: 'content_management',
      previllege: this.userService.hasMenu('SPORTS_P_M_CONTENT_MANAGENT'),
      others: [
        {
          name: 'footer',
          icon: 'footer',
          code: 'SPORTS_P_SM_FOOTER',
          url: 'footer'
        },
        {
          name: 'nav',
          icon: 'group',
          code: 'SPORTS_P_SM_NAVIGATION',
          url: 'nav'
        }
      ]
    },
    {
      header: 'ticket_management',
      previllege: this.userService.hasMenu('SPORTS_P_M_TICKETS_MANAGEMENT'),
      others: [
        {
          name: 'tickets_sportif',
          icon: 'ticket',
          code: 'SPORTS_P_SM_PARIS_SPORTIF',
          url: 'tickets/sports'
        },
        {
          name: 'tickets_jackpot',
          icon: 'ticket',
          code: 'SPORTS_P_SM_JACKPOT',
          url: 'tickets/jackpot'
        },
        {
          name: 'tickets_lotto',
          icon: 'ticket',
          code: 'SPORTS_P_SM_LOTTO',
          url: 'tickets/loto'
        },
        {
          name: 'tickets_hippique',
          icon: 'ticket',
          code: 'SPORTS_P_SM_HIPPIQUE',
          url: 'tickets/hippique'
        },
        {
          name: 'suspended_payment',
          icon: 'lock',
          code: 'SPORTS_P_SM_SUSPENDED_TICKETS',
          url: 'suspended-payment'
        }
      ]
    },
    {
      header: 'partner_management',
      previllege: this.userService.hasMenu('SPORTS_P_M_GESTION_PARTNER'),
      others: [
        {
          name: 'partners',
          icon: 'groups',
          code: 'SPORTS_P_SM_PARTNERS',
          url: 'partners'
        },
        {
          name: 'products',
          icon: 'quote',
          code: 'SPORTS_P_SM_PRODUCTS',
          url: 'products'
        },
        {
          name: 'product_type',
          icon: 'record_create',
          code: 'SPORTS_P_SM_PRODUCT_TYPES',
          url: 'product-type'
        }
      ]
    },
    {
      header: 'ml_news',
      previllege: this.userService.hasMenu('SPORTS_P_M_GESTION_NEWS'),
      others: [
        {
          name: 'avis_expert',
          icon: 'resource_capacity',
          code: 'SPORTS_P_SM_AVIS_EXPERT',
          url: 'avis-expert'
        },
        {
          name: 'promotions',
          icon: 'ribbon',
          code: 'SPORTS_P_SM_PROMOTIONS',
          url: 'promotions'
        },
        {
          name: 'speciale-cagnotte',
          icon: 'ribbon',
          code: 'SPORTS_P_SM_PROMOTIONS',
          url: 'speciale-cagnotte'
        },
      ]
    },

    {
      header: 'settings',
      previllege: this.userService.hasMenu('SPORTS_P_M_SETTINGS'),
      others: [
        {
          name: 'settings',
          icon: 'bet-settings',
          code: 'SPORTS_P_SM_SETTINGS',
          url: 'bet-settings'
        },
        {
          name: 'bonus_settings',
          icon: 'bonus',
          code: 'SPORTS_P_SM_BONUS',
          url: 'bonus-settings'
        },
        {
          name: 'cashout_configs',
          icon: 'moneybag',
          code: 'SPORTS_P_SM_CASHOUT',
          url: 'cashout-settings'
        },
        {
          name: 'tax_configuration',
          icon: 'tax-configuration',
          code: 'SPORTS_P_SM_TAX_CONFIG',
          url: 'tax-configuration'
        },
        {
          name: 'package_configuration',
          icon: 'package-config',
          code: 'SPORTS_P_SM_PACKAGE_CONFIG',
          url: 'package-config'
        },
        {
          name: 'dashboard_configuration',
          icon: 'dashboard-settings',
          code: 'SPORTS_P_SM_DASHBOARD_CONFIG',
          url: 'dashboard-config'
        },
        {
          name: 'notification_configuration',
          icon: 'dashboard-settings',
          code: 'SPORTS_P_SM_NOTIFICATIONS',
          url: 'notification'
        },
      ]
    },
    {
      header: 'tax_management',
      previllege: this.userService.hasMenu('P_M_TAX_MANAGEMENT') || true,
      others: [
        {
          name: "tax_payment_number_gen",
          icon: 'tax-configuration',
          code: 'P_SM_TAX_PAYMENT_REGISTRATION',
          url: 'tax-payment'
        }
      ]
    },
    {
      header: 'betting_configs',
      previllege: this.userService.hasMenu('SPORTS_P_M_BETTING_CONFIGS'),
      others: [
        {
          name: 'event_restriction',
          icon: 'bet-settings',
          code: 'P_SM_EVENT_RESTRICTION',
          url: 'event-restriction'
        },
      ]
    },
    {
      header: 'risk_configurations',
      previllege: this.userService.hasMenu('SPORTS_P_M_SETTINGS_V2'),
      others: [
        {
          name: 'limits_management',
          icon: 'bet-settings',
          code: 'SPORTS_P_SM_SETTINGS',
          url: 'risk-config'
        }
      ]
    },
    {
      header: 'gestion_revenue',
      previllege: this.userService.hasMenu('SPORTS_P_M_GESTION_REVENUE'),
      others: [
        {
          name: 'revenue_sharing',
          icon: 'bet-settings',
          code: 'SPORTS_P_SM_PARTNERS_REVENUE_SHARE',
          url: 'PRS'
        }
      ]
    },
    {
      header: 'provider_management',
      previllege: this.userService.hasMenu('SPORTS_P_M_PROVIDERS'),
      others: [
        {
          name: 'payment_providers',
          icon: 'bet-settings',
          code: 'SPORTS_P_SM_PROVIDERS',
          url: 'providers'
        },
        {
          name: 'payment_configurations',
          icon: 'bet-settings',
          code: 'SPORTS_P_SM_PAYMENTS',
          url: 'payments'
        },
        {
          name: 'blacklist',
          icon: 'bet-settings',
          code: 'SPORTS_P_SM_BLACKLISTS',
          url: 'black-list'
        }
      ]
    },
    {
      header: this.translate.instant('risk_threshold_config'),
      previllege: this.userService.hasMenu('SPORTS_RISK_P_M_THRESHOLD_CONFIG'),
      others: [
        {
          name: this.translate.instant('risk_monitored_elements'),
          icon: 'bet-settings',
          code: 'SPORTS_RISK_P_SM_MONITOR_VALUE',
          url: 'threshold-config/monitored-values'
        },
        {
          name: this.translate.instant('limits'),
          icon: 'bet-settings',
          code: 'SPORTS_RISK_P_SM_LIMITS',
          url: 'threshold-config/limits'
        },
        {
          name: this.translate.instant('risk_thresholds'),
          icon: 'bet-settings',
          code: 'SPORTS_RISK_P_SM_THRESHOLD',
          url: 'threshold-config/thresholds'
        },
        {
          name: this.translate.instant('risk_threshold_rule_groups'),
          icon: 'bet-settings',
          code: 'SPORTS_RISK_P_SM_THRESHOLD_RULE_GROUP',
          url: 'threshold-config/threshold-rule-groups'
        },
        {
          name: this.translate.instant('risk_threshold_rules'),
          icon: 'bet-settings',
          code: 'SPORTS_RISK_P_SM_THRESHOLD_RULE',
          url: 'threshold-config/threshold-rules'
        },
      ],
    },
    {
      header: 'goal_configuration',
      previllege: this.userService.hasMenu('SPORTS_P_M_GOAL_CONFIG'),
      others: [
        {
          name: 'goal_type',
          icon: 'bet-settings',
          code: 'SPORTS_P_SM_GOAL_TYPES',
          url: 'goal/types'
        },
        {
          name: 'winning_rules',
          icon: 'bet-settings',
          code: 'SPORTS_P_SM_GOAL_WINNING_RULES',
          url: 'goal/rules'
        },
        {
          name: 'jackpot_config',
          icon: 'bet-settings',
          code: 'SPORTS_P_SM_GOAL_JACPOT_CONFIG',
          url: 'goal/jackpot'
        },
        {
          name: 'goal_package',
          icon: 'bet-settings',
          code: 'SPORTS_P_SM_GOAL_PACKAGE',
          url: 'goal/packages'
        },
      ]
    },
    {
      header: 'goal_management',
      previllege: this.userService.hasMenu('SPORTS_P_M_GOAL_MANAGEMENT'),
      others: [
        {
          name: 'goal',
          icon: 'bet-settings',
          code: 'SPORTS_P_SM_GOAL_MANAGEMENT',
          url: 'goal'
        }
      ]
    }
  ];
  constructor(public route: Router,
              public uiService: UiService,
              private userService: UserManagerService,
              private translate: TranslateService) {
  }

  ngOnInit() {
  }
  expand(menuIndex) {
    if (menuIndex !== this.userService.sideMenu.submenu) {
      this.userService.sideMenu.submenu = menuIndex;
      this.userService.sideMenu.expanded = true;
    } else {
      this.userService.sideMenu.expanded = !this.userService.sideMenu.expanded;
    }
  }
}
